require('./bootstrap');
require('jquery-mask-plugin');
require('./jquery.zoom')

import 'lightbox2';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick.min.js';

import 'paroller.js';
import axios from 'axios';

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';



// import 'intl-tel-input/build/css/intlTelInput.css';
// import intlTelInput from 'intl-tel-input';
// import { tns } from "tiny-slider/src/tiny-slider";

window.Vue = require('vue').default

Vue.use(VueSweetalert2, {
    confirmButtonColor: '#202945',
});
Vue.use(require('../plugins/caw'))


// window.AOS = require('aos');
// AOS.init({
//     once: true,
//     duration: 800
// });

//**************** MODAL - COOKIES *********************
// $("#btn_close_cookies_info").on("click", function () {
//     $('#cookies-info').remove();

//     window.localStorage.setItem('cookies', 'sim');
// });

// if (window.localStorage.getItem("cookies") === null) {

//     $("#cookies-info").show();
// }
//**************** MODAL - COOKIES *********************


// #######################################################
// HOME


function initializeCarousel() {
    $('.slider-topo').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        autoplay: true,
        arrows: false,
        dots: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        autoplaySpeed: 7500,
    });

    $('.produtos-destaque').slick({
        mobileFirst: true,
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        arrows: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        autoplaySpeed: 7500,
        responsive: [
            {
                breakpoint: 920,
                settings: {
                    centerMode: true,
                    slidesToShow: 2,
                }
            }
        ]
    });

   $('.depoimentos').slick({
       mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        arrows: false,
        dots: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        autoplaySpeed: 7500,
        responsive: [
            {
                breakpoint: 920,
                settings: {
                    slidesToShow: 3,
                }
            }
        ]
    });

    $('.galeria').slick({
        mobileFirst: true,
        centerMode: true,
         slidesToShow: 1,
         slidesToScroll: 1,
         autoplay: true,
         arrows: false,
         dots: true,
         pauseOnHover: true,
         pauseOnFocus: true,
         autoplaySpeed: 7500,
         responsive: [
             {
                 breakpoint: 920,
                 settings: {
                     slidesToShow: 2,
                 }
             }
         ]
     });

     $('.pilares').slick({
        mobileFirst: true,
         slidesToShow: 1,
         slidesToScroll: 1,
         autoplay: false,
         arrows: true,
         dots: false,
         pauseOnHover: true,
         pauseOnFocus: true,
         autoplaySpeed: 7500,
         responsive: [
             {
                 breakpoint: 920,
                 settings: 'unslick'
             }
         ]
     });

     $('.materiais-tecnicos').slick({
        mobileFirst: true,
        // centerMode: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        arrows: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        autoplaySpeed: 7500,
        responsive: [
            {
                breakpoint: 920,
                settings: {
                    slidesToShow: 3,
                }
            }
        ]
    });

    $('.cases-sucesso').slick({
        mobileFirst: true,
        centerMode: true,
         slidesToShow: 1,
         slidesToScroll: 1,
         autoplay: true,
         arrows: true,
         dots: false,
         pauseOnHover: true,
         pauseOnFocus: true,
         autoplaySpeed: 7500,
         responsive: [
             {
                 breakpoint: 920,
                 settings: {
                     slidesToShow: 2,
                 }
             }
         ]
     });


    $('.galeria-produto').slick({
        mobileFirst: true,
        centerMode: false,
         slidesToShow: 1,
         slidesToScroll: 1,
         autoplay: true,
         arrows: false,
         dots: true,
         pauseOnHover: true,
         pauseOnFocus: true,
         autoplaySpeed: 7500,
         infinite: false,
     });
    $('.galeria-aplicacoes-produto').slick({
        mobileFirst: true,
        centerMode: false,
         slidesToShow: 1,
         slidesToScroll: 1,
         autoplay: true,
         arrows: true,
         dots: false,
         pauseOnHover: true,
         pauseOnFocus: true,
         autoplaySpeed: 7500,
         infinite: false,
         responsive: [
            {
                breakpoint: 920,
                settings: {
                    slidesToShow: 3,
                    enterMode: true,
                }
            }
        ]
     });
    $('.produtos-relacionados').slick({
        mobileFirst: true,
        centerMode: false,
         slidesToShow: 1,
         slidesToScroll: 1,
         autoplay: true,
         arrows: true,
         dots: false,
         pauseOnHover: true,
         pauseOnFocus: true,
         autoplaySpeed: 7500,
         infinite: true,
         responsive: [
            {
                breakpoint: 920,
                settings: {
                    slidesToShow: 2,
                    centerMode: true,
                }
            }
        ]
     });

    $('.parallax').paroller();
}
/*
function imageZoom(obj){

        var targetWidth = $(obj.target).outerWidth() * 2;
        var targetHeight = $(obj.target).outerHeight() * 2;

        var sourceWidth, sourceHeight = 0;

        const img = new Image();
        console.log(obj.originalEvent)
        img.onload = function() {
            sourceWidth = this.width * 2;
            sourceHeight = this.height * 2;
            // console.log(sourceHeight, sourceWidth);

            var xRatio = (img.width - targetWidth) / sourceWidth;
            var yRatio = (img.height - targetHeight) / sourceHeight;

            // console.log(xRatio, yRatio);

            var left = (obj.pageX - obj.target.offsetLeft),
                top = (obj.pageY - obj.target.offsetTop);

            top = Math.max(Math.min(top, sourceHeight), 0);
            left = Math.max(Math.min(left, sourceWidth), 0);

            $(obj.target).css('background-position', (obj.originalEvent.offsetX * -xRatio) + 'px ' + (obj.originalEvent.offsetY * -yRatio) + 'px');
            $(obj.target).css('background-size', '00%');
            $(obj.target).css('background-repeat', 'no-repeat');

            // console.log((left * -xRatio) + 'px ' + (top * -yRatio) + 'px');
            // console.log($(obj.target).css('background-position'));
        }
        img.src = $(obj.target).css("background-image").slice(4, -1).replace(/"/g, "");
} */

jQuery(function(){

    // $('#nav-item-produtos').mouseenter(() => {$('.categorias-produtos').addClass('show')}).mouseleave(() => {$('.categorias-produtos').removeClass('show')});
    $('.youtube-thumbnail').on('click', function(){
        $(this).find('img').remove();
        $(this).find('iframe').attr('src', $(this).find('iframe').attr('a-src'));
        $(this).find('iframe').removeClass('d-none');
        $(this).removeClass('img');
        $(this).off('click');
    });

    initializeCarousel();
    onresize()
});

function onresize(){
    if(window.innerWidth > 768){
        $('img.produto-zoom')
            .wrap('<span style="display:inline-block"></span>')
            .css('display', 'block')
            .parent()
            .zoom();
    }

    //banner popups
    $('.banner-popup .popup').each(function(){

        let w = window.innerWidth > 768 ? 1920 : 640;

        let banner_height = $(this).parent().height();
        let banner_width = $(this).parent().width();

        let left = parseInt($(this).attr('attr-x')) / w * window.innerWidth;
        left -= 20;
        let top = parseInt($(this).attr('attr-y')) / 640 * banner_height;
        top -= 20;
        $(this).find('.blinking-dot').css('left', left+'px').css('top', top+'px');

        let modal_height = $(this).find('.modal-popup').outerHeight();
        let modal_width = $(this).find('.modal-popup').outerWidth();
        // debugger
        if(top + modal_height > banner_height)
            top = banner_height - modal_height - 10;
        top = top > 25 ? top : 25;

        if(left + modal_width > banner_width)
            left = banner_width - modal_width - 10;
        left = left > 20 ? left : 20;
        $(this).find('.modal-popup').css('left', left+'px').css('top', top+'px');
    });
}

window.openPopup = function(id){
    closePopup();
    $('#'+id).find('.modal-popup').slideDown();
}

window.closePopup = function(){
    $('.banner-popup').find('.modal-popup').slideUp();
}

window.onresize = onresize;
window.onscroll = (evt) => {
    if($(window).scrollTop() > 400){
        $('#btnGotoTop').removeClass('invisible');
    }else{
        $('#btnGotoTop').addClass('invisible');
    }
}

if (window.vue == undefined) {
    window.vue = new Vue({
        data: function () {
            return {
                contato: {},
                carreira: {},
                pedido: {produtos: []},
                orcamento_show: 0,
                page:1,
            }
        },
        el: '#app',
        watch: {
            'orcamento_show': function(){
                this.modalOpen(this.orcamento_show > 0)
            }
        },
        mounted: function(){
            this.pedido = window.localStorage.getItem('pedido') ? JSON.parse(window.localStorage.getItem('pedido')) : {produtos: []};
        },
        computed: {
            'list_produtos': function(){
                return this.form.produtos.slice(0, this.page * 6);
            }
        },
        methods: {
            modalOpen(open){
                if(open){
                    window.scrollYWhenModalOpened = $(window).scrollTop();
                    $('body').addClass('modal-open');
                }else{
                    $('body').removeClass('modal-open');
                    $(window).scrollTop(window.scrollYWhenModalOpened)
                }
            },
            envia_contato(url){
                this.form.loading = true;
                axios.post(url, this.contato)
                    .then((res) => {
                        this.form.loading = false;
                        this.$swal(res.data.msg);
                        this.contato = {};
                    })
                    .catch((res) => {
                        this.$swal('Ocorreu um erro ao enviar, tente novamente.');
                        console.log(res);
                        this.form.loading = false;
                    });
            },

            envia_carreira(url){
                var data = new FormData();
                for(let i in this.carreira){
                    data.append(i, this.carreira[i]);
                }

                this.form.loading = true;
                axios.post(url, data)
                    .then((res) => {
                        this.form.loading = false;
                        this.$swal(res.data.msg);
                        this.carreira = {};
                    })
                    .catch((res) => {
                        this.$swal('Ocorreu um erro ao enviar, tente novamente.');
                        console.log(res);
                        this.form.loading = false;
                    });
            },

            updAnexoCurriculo(e){
                if(e.target.files.length > 0){
                    this.carreira.anexo = e.target.files[0];
                }else{
                    this.carreira.anexo = '';
                }
                this.$forceUpdate();
            },

            addProdutoPedido(produto){
                for(let i in this.pedido.produtos){
                    if(this.pedido.produtos[i].uniqid == produto.uniqid){
                        this.orcamento_show = 1;
                        return;
                    }
                }

                this.pedido.produtos.push({...produto, qtde: 1, cor: produto.cores.length > 0 ? produto.cores[0] : null, pedido_por_selecionado: null});
                window.localStorage.setItem('pedido', JSON.stringify(this.pedido));
                this.orcamento_show = 1;
                this.$forceUpdate();
            },

            removeProdutoPedido(index){
                this.pedido.produtos.splice(index, 1);
                window.localStorage.setItem('pedido', JSON.stringify(this.pedido))
                this.$forceUpdate();
            },

            qtdeProdutoUpdate(index, qtde){
                this.pedido.produtos[index].qtde = qtde;
                if(this.pedido.produtos[index].qtde <= 0){
                    this.removeProdutoPedido(index);
                }
                window.localStorage.setItem('pedido', JSON.stringify(this.pedido))
                this.$forceUpdate();
            },

            corProdutoUpdate(index, cor){
                this.pedido.produtos[index].cor = cor;
                window.localStorage.setItem('pedido', JSON.stringify(this.pedido))
                this.$forceUpdate();
            },

            updPedido(){
                window.localStorage.setItem('pedido', JSON.stringify(this.pedido))
                this.$forceUpdate();
            },

            enviaOrcamento(url){
                if(this.orcamento_show == 2){
                    this.form.loading = true;
                    axios.post(url, this.pedido)
                        .then((res) => {
                            this.form.loading = false;
                            this.pedido.produtos = [];
                            this.updPedido();
                            this.orcamento_show = 3;
                        })
                        .catch((res) => {
                            this.$swal('Ocorreu um erro ao enviar, tente novamente.');
                            console.log(res);
                            this.form.loading = false;
                        });
                }else if(this.orcamento_show == 1){
                    this.orcamento_show++;
                }
                return false;
            }

        }
    });
}
